(function() {

    document.addEventListener("DOMContentLoaded", (event) => {
        if(document.querySelector('.js-read-more')) {
            const readMoreButtons = document.querySelectorAll('.js-read-more');
            readMoreButtons.forEach(button => {
                button.addEventListener('click', (event) => {
                    const container = button.closest('.js-read-more-container');
                    const text = container.querySelector('.js-read-more-text');
                    if (text.style.maxHeight) {
                        text.style.maxHeight = null;
                        text.classList.remove('expanded');
                        button.setAttribute('aria-expanded', 'false');
                        button.querySelector('.read-more__text').textContent = button.dataset.moreText;
                    } else {
                        text.style.maxHeight = text.scrollHeight + 'px';
                        text.classList.add('expanded');
                        button.setAttribute('aria-expanded', 'true');
                        button.querySelector('.read-more__text').textContent = button.dataset.lessText;
                    }
                });
            });
          }
    });

})();